module.exports = __webpack_public_path__ + "img/mj_icon_redraw.615bc7c6.png";